import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix Number Field icon. Exported from Figma (Bombiix 2026). */
const NumberFieldIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path d="M14 4.66602L11.3333 15.3327M8.66667 4.66602L6 15.3327M5.33333 7.33268H16M4 12.666H14.6667" stroke="currentColor" strokeLinecap="round" />
  </svg>
);

export default NumberFieldIcon;
